import React from 'react';
import theme from '../../styles/theme';

const BrandLogo = ({
  label = 'Waggy',
  showText = true,
  size = 32,
  textSize = '1.25rem',
  gap = '10px',
  textColor = '#1B3A5C',
  markColor = '#1B3A5C',
  symbolColor = '#FFFFFF',
  accentColor = '#F4945F',
}) => {
  return (
    <span style={{ display: 'inline-flex', alignItems: 'center', gap }}>
      <svg
        width={size}
        height={size}
        viewBox="0 0 32 32"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        role="img"
        aria-label={`${label} logo`}
      >
        <rect x="1" y="1" width="30" height="30" rx="9" fill={markColor} />
        <path
          d="M8.5 22.5L12 10.5L16 18L20 10.5L23.5 22.5"
          stroke={symbolColor}
          strokeWidth="2.4"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <circle cx="25" cy="7" r="3" fill={accentColor} />
      </svg>

      {showText && (
        <span
          style={{
            fontSize: textSize,
            fontWeight: 700,
            color: textColor,
            fontFamily: theme.typography.fontFamily.heading,
            letterSpacing: '-0.2px',
            lineHeight: 1,
          }}
        >
          {label}
        </span>
      )}
    </span>
  );
};

export default BrandLogo;